"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _theme = _interopRequireDefault(require("../../../theme"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Note: the SliderHandle needs to be a class components as refs are passed to it by the slider 
class SliderHandle extends _react.default.Component {
  state = {
    sliding: false
  }; // the clickFocus class method is required on the 
  // SliderHandle component by the parent component

  clickFocus() {}

  render() {
    const {
      value,
      handleBarColor,
      ...otherProps
    } = this.props;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledSliderHandle, {
      value: value,
      sliding: this.state.sliding,
      onMouseDown: () => this.setState({
        sliding: true
      }),
      onMouseUp: () => this.setState({
        sliding: false
      }),
      ...otherProps,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SliderHandleBar, {
        handleBarColor: handleBarColor
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SliderHandleBar, {
        handleBarColor: handleBarColor
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SliderHandleBar, {
        handleBarColor: handleBarColor
      })]
    });
  }

}

SliderHandle.propTypes = {
  handleBarColor: _propTypes.default.string,
  handleColor: _propTypes.default.string,
  handleSize: _propTypes.default.string
};
SliderHandle.defaultProps = {
  handleBarColor: undefined,
  handleColor: undefined,
  handleSize: _theme.default.space[7]
};
var _default = SliderHandle;
exports.default = _default;